module.exports = __webpack_public_path__ + "static/img/1073.8bf4f4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1073.jpg
// module id = 255
// module chunks = 0